var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_7958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31226 17.6336L10.0779 12.8992L13.2029 16.0242L19.531 9.70391V13.2773H21.0935V7.02734H14.8435V8.58984H18.4169L13.2029 13.8039L10.0779 10.6789L4.23726 16.5586L5.31226 17.6336ZM2.52319 24.9961C1.80444 24.9961 1.20444 24.7555 0.723193 24.2742C0.240901 23.7919 -0.000244141 23.1914 -0.000244141 22.4727V2.51953C-0.000244141 1.80078 0.240901 1.20078 0.723193 0.719531C1.20444 0.237239 1.80444 -0.00390625 2.52319 -0.00390625H22.4763C23.1951 -0.00390625 23.7951 0.237239 24.2763 0.719531C24.7586 1.20078 24.9998 1.80078 24.9998 2.51953V22.4727C24.9998 23.1914 24.7591 23.7914 24.2779 24.2727C23.7956 24.7549 23.1951 24.9961 22.4763 24.9961H2.52319ZM2.52319 23.4336H22.4763C22.7159 23.4336 22.9362 23.3336 23.1373 23.1336C23.3373 22.9325 23.4373 22.7122 23.4373 22.4727V2.51953C23.4373 2.27995 23.3373 2.05963 23.1373 1.85859C22.9362 1.65859 22.7159 1.55859 22.4763 1.55859H2.52319C2.28361 1.55859 2.0633 1.65859 1.86226 1.85859C1.66226 2.05963 1.56226 2.27995 1.56226 2.51953V22.4727C1.56226 22.7122 1.66226 22.9325 1.86226 23.1336C2.0633 23.3336 2.28361 23.4336 2.52319 23.4336Z",
    fill: "#BA3737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_7958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsFilled);
export default __webpack_public_path__ + "static/media/Insights-filled.f8000a16f3a7c083709c5c4432e74d82.svg";
export { ForwardRef as ReactComponent };